module.exports = "<p>\n  car-details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/car/car-details/car-details.component.html
// module id = 155
// module chunks = 1